import { injectable } from "inversify"

export interface IStorageService {
    Get(key: string): string
    Set(key: string, value: string)

    GetNumber(key: string): number
    SetNumber(key: string, value: number)
}

@injectable()
abstract class StorageService implements IStorageService {

    abstract Get(key: string): string
    abstract Set(key: string, value: string)

    GetNumber(key: string): number {
        let data = this.Get(key)
        return data == null ? null : +data
    }

    SetNumber(key: string, value: number) {
        this.Set(key, value.toString())
    }
}

export interface ILocalStorageService extends IStorageService { }

@injectable()
export class LocalStorageService extends StorageService implements ILocalStorageService {

    Set(key: string, value: string) {
        window.localStorage.setItem(key, value)
    }

    Get(key: string): string {
        return window.localStorage.getItem(key)
    }
}

export interface ISessionStorageService extends IStorageService { }

@injectable()
export class SessionStorageService extends StorageService implements ISessionStorageService {

    Set(key: string, value: string) {
        window.sessionStorage.setItem(key, value)
    }

    Get(key: string): string {
        return window.sessionStorage.getItem(key)
    }
}